module.exports = __webpack_public_path__ + "static/basic-flow_7-dd27c612d3831c21a70811e45b4338ed.png";